
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.33.65l.75 1.518a.214.214 0 00.16.118l1.677.243a.214.214 0 01.119.366L9.823 4.077a.214.214 0 00-.062.19l.287 1.67a.215.215 0 01-.312.226l-1.499-.788a.214.214 0 00-.2 0l-1.498.788a.214.214 0 01-.311-.227l.286-1.669a.214.214 0 00-.062-.19L5.24 2.895a.215.215 0 01.12-.366l1.675-.243c.07-.01.13-.054.162-.118L7.946.65a.215.215 0 01.384 0z","fill":"#D08A21"}}),_c('path',{attrs:{"d":"M8.036 9.788L.464 5.736a.214.214 0 00-.316.19v3.062c0 .08.044.152.113.19l7.775 4.16c.063.034.14.034.202 0l7.775-4.16a.215.215 0 00.113-.19V5.925a.214.214 0 00-.315-.19L8.238 9.789a.215.215 0 01-.202 0z","fill":"#D08A21"}}),_c('path',{attrs:{"d":"M8.036 15.955L.464 11.903a.214.214 0 00-.316.19v3.062c0 .08.044.152.113.19l7.775 4.16c.063.034.14.034.202 0l7.775-4.16a.215.215 0 00.113-.19v-3.063a.215.215 0 00-.315-.189l-7.573 4.052a.213.213 0 01-.202 0z","fill":"#D08A21"}})])
          )
        }
      }
    